interface DurationCalculationProps {
  fullDayHours: number;
  halfDayHours: number;
  onChange: (key: string, value: number) => void;
}

export function DurationCalculation({ fullDayHours, halfDayHours, onChange }: DurationCalculationProps) {
  return (
    <div>
      <h4 style={{ fontSize: '0.95rem', fontWeight: 600, color: '#00303c', marginBottom: '1rem' }}>
        Calcul des durées
      </h4>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <HourInput
          label="Heures pour journée complète"
          value={fullDayHours}
          onChange={(v: number) => onChange('fullDayHours', v)}
          defaultVal={8}
        />
        <HourInput
          label="Heures pour demi-journée"
          value={halfDayHours}
          onChange={(v: number) => onChange('halfDayHours', v)}
          defaultVal={4}
        />
      </div>
    </div>
  );
}

interface HourInputProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  defaultVal: number;
}

function HourInput({ label, value, onChange, defaultVal }: HourInputProps) {
  return (
    <div>
      <label
        style={{
          display: 'block',
          marginBottom: '0.5rem',
          fontSize: '0.85rem',
          fontWeight: 600,
          color: '#00303c',
        }}
      >
        {label}
      </label>
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value) || defaultVal)}
        min={1}
        style={{
          width: '100%',
          padding: '0.75rem',
          fontSize: '1rem',
          border: '2px solid #e5e7eb',
          borderRadius: '8px',
          outline: 'none',
        }}
        onFocus={(e) => (e.currentTarget.style.borderColor = '#00758d')}
        onBlur={(e) => (e.currentTarget.style.borderColor = '#e5e7eb')}
      />
      <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.25rem' }}>
        Défaut: {defaultVal} heures
      </p>
    </div>
  );
}
